import {
  useEffect,
  useState,
} from "react"

import { useDarkMode } from "src/contexts/DarkModeContext"
import { useFollowedUsers } from "src/contexts/FollowedUsersContext"
import { getColorScheme } from "src/utils"

export function useColorScheme() {
  const [
    colorScheme,
    setColorScheme,
  ] = useState<"light" | "dark">(getColorScheme())

  const { currentDeviceSettings } = useFollowedUsers()
  const currentTheme = currentDeviceSettings.theme
  const currentThemeAppearance = currentDeviceSettings.theme_appearance

  const darkMode = useDarkMode()

  useEffect(
    () => {
      // getColorScheme will not return the correct values unless it is delayed
      setTimeout(
        () => setColorScheme(getColorScheme()),
        0,
      )
    },
    [
      currentTheme,
      currentThemeAppearance,
      darkMode,
      setColorScheme,
    ],
  )

  return colorScheme
}
